import React from 'react';

import PropsTypes from 'prop-types';

import {
    ContentSection,
    Content,
    Sidebar,
} from 'wanderu-components';
import { localize } from 'wanderu-i18n';

import ValueProp from '../ValueProp/ValueProp';

import styles from './AboutWanderu.scss';

function AboutWanderu(props) {
    const {
        description,
        title,
    } = props;

    return (
        <ContentSection
            className={styles.aboutWanderu}
            id="cg-partner-info-title"
            layoutClassName={styles.layout}
            title={title}
        >
            <Content className={styles.aboutWanderuContent}>
                <p>
                    {description}
                </p>
            </Content>
            <Sidebar>
                <ValueProp compact />
            </Sidebar>
        </ContentSection>
    );
}

AboutWanderu.propTypes = {
    description: PropsTypes.string.isRequired,
    title: PropsTypes.string.isRequired,
};

export { AboutWanderu };
export default localize(AboutWanderu, ['t'], 'baseApp');
